import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useOnClickOutside } from '../utils/customHooks';
import flotte from '../data/flotte.json';
import Heading from '../Components/Heading/Heading';

const Flotte = () => {

    const [showSort, setShowSort] = useState(false);
    const [data] = useState(flotte);
    const [sort, setSort] = useState({ asc: true, index: 1, key: 'inServiceYear', value: 'Indienststellung' });
    const sortOptions = [ { key: 'name', value: 'Name' }, { key: 'inServiceYear', value: 'Indienststellung'} ];
    const sortRef = useRef(null);
    useOnClickOutside(sortRef, () => setShowSort(false));

    const handleSort = (index, {key, value}) => {
        // Dialog ausblenden
        setShowSort(false);
        // Sortierung setzen
        setSort({...sort, index, value, key});

        data.sort((a, b) => {
            if (a[key] < b[key]) return sort.asc? -1 : 1;
            if (a[key] > b[key]) return sort.asc? 1 : -1;

            return 0;
        });
    }

    return (
        <div>

            <div className="flex justify-between items-center relative">
                <Heading>Flotte</Heading>
                <div ref={sortRef}>
                    <button onClick={() => setShowSort(!showSort)} className="text-slate-500 border border-slate-300 dark:border-slate-700 rounded p-1 hover:bg-slate-200">
                        <svg className="w-4 h-4 stroke-current stroke-[1.5]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <title>Sortierung</title>
                            <path d="M4 9.2437L9.2437 4V20" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M20.4874 14.7563L15.2437 20L15.2437 4" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>

                    </button>
                    {/* Modales Panel für Sortierung */}
                    {showSort &&
                    <div className='bg-white dark:bg-night-sky-blue-900 rounded-lg text-sm absolute top-0 right-0 z-20 mt-10 text-stone-700 dark:text-stone-300 shadow-md overflow-hidden'>
                        <div className="flex items-center p-3 border-b border-stone-200 dark:border-stone-800 bg-slate-200 dark:bg-night-sky-blue-800">
                            <h3 className='font-light'>Sortierung nach...</h3>
                            <button className='ml-6 text-aida-blue hover:text-stone-700 dark:hover:text-stone-300'>
                                {sort.asc ?
                                <svg onClick={() => setSort({ ...sort, asc: !sort.asc })} className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <title>aufsteigend</title>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
                                </svg>
                                :
                                <svg onClick={() => setSort({ ...sort, asc: !sort.asc })} className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <title>absteigend</title>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                                </svg>
                                }
                            </button>
                        </div>
                        <ul className='flex flex-col'>
                            {sortOptions.map((option, idx) => {
                                return (
                                    <li key={idx} onClick={() => handleSort(idx, option)} className={`flex items-center gap-2 p-3 cursor-pointer border-b border-stone-200 dark:border-stone-800 hover:bg-slate-100 dark:hover:bg-slate-900 ${idx === sort.index && 'text-aida-blue'}`}>
                                        {option.value}
                                        {idx === sort.index &&
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                        }
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    }
                </div>
            </div>

            <div className="grid justify-center gap-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr)' }}>
                {data.map(schiff => {
                    return (
                        <Link key={schiff.name} to={`/schiff/${schiff.name}`}>
                            <div className="relative aspect-[3/2] overflow-hidden shadow-md rounded-xl transition hover:-translate-y-2">
                                <img className="object-cover object-bottom w-full h-full" src={`${process.env.PUBLIC_URL}/assets/images/flotte/${schiff.image}`} alt={schiff.fullName} />
                                <div className="absolute bottom-0 left-0 w-full px-6 pt-10 pb-4 text-2xl font-light bg-white dark:bg-night-sky-blue-600 dark:text-stone-300" style={{ clipPath: 'ellipse(70% 105% at 25% 135%)' }}>
                                    {schiff.fullName}
                                    {!schiff.active &&
                                        <span className="text-sm"> (a.D. {schiff.untilYear})</span>
                                    }
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>

        </div>
    );
}

export default Flotte;